import $ from "jquery";

export const Passport = function () {
  if (!$(".passport-page").length) return false;

  const $elms = {
    tabs: $(".js-passport-tab"),
    panels: $(".js-passport-panel"),
    btnDownload: $(".btn-download-passport"),
    roleInfoBtn: $(".js-role"),
    roleCardPopup: $(".js-role-card-popup"),
    roleCardPopupClose: $(".js-role-card-popup-close"),
  };

  const roleColor = $elms.roleInfoBtn.first().attr("data-color");
  const $activeTab = $elms.tabs.filter(".is-active");
  $activeTab.css("background-color", roleColor);
  $activeTab.parent().css("border-bottom", `1px solid ${roleColor}`);

  $elms.tabs.on("click", function () {
    const $tab = $(this);
    const target = $tab.data("tab");

    $elms.tabs
      .removeClass("is-active")
      .attr("aria-selected", "false")
      .css("background-color", "");
    $tab
      .addClass("is-active")
      .attr("aria-selected", "true")
      .css("background-color", roleColor);

    $elms.panels.removeClass("is-active").attr("hidden", true);
    $elms.panels
      .filter(`[data-panel="${target}"]`)
      .addClass("is-active")
      .removeAttr("hidden");
  });

  $elms.btnDownload.on("click", function () {
    window.open(window.CFG.siteURL + `/export-pdf`, "_blank");
  });

  $elms.roleInfoBtn.on("click", function () {
    const learningGoalId = $(this).attr("data-learning-goal-id");
    $elms.roleCardPopup.removeClass("is-active");
    $elms.roleCardPopup
      .filter(`[data-learning-goal-id="${learningGoalId}"]`)
      .css("background-color", roleColor)
      .addClass("is-active");
  });

  $elms.roleCardPopupClose.on("click", function () {
    $elms.roleCardPopup.removeClass("is-active");
  });
};
